import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from '../components/Breadcrumb';
import { apiPost } from '../api';
import './DashboardPage.css';

/** Create a project. Reached at /projects/new. */
function ProjectFormPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: '', description: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const savingRef = useRef(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (savingRef.current) return;
    savingRef.current = true;
    setSaving(true);
    setError('');
    try {
      const project = await apiPost('/projects', formData);
      navigate(`/projects/${project.id}`);
    } catch (err) {
      console.error('Error creating project:', err);
      setError('Failed to create project. Check your access and try again.');
      savingRef.current = false;
      setSaving(false);
    }
  };

  return (
    <div className="dashboard-page">
      <div className="container">
        <Breadcrumb items={[{ label: 'Projects', to: '/projects' }, { label: 'New project' }]} />
        <h1>New Project</h1>

        {error && <div className="error-banner">{error}</div>}

        <div className="card">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Project Name *</label>
              <input
                id="name"
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="description">Description</label>
              <textarea
                id="description"
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                rows="3"
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary" disabled={saving}>
                {saving ? 'Creating...' : 'Create Project'}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate('/projects')}
                disabled={saving}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ProjectFormPage;
